import { UserPrivileges } from '@livv/models';
import { INTERNAL_EMAIL_SUFFIX } from '@livv/models/consts/users';

type NeededPrivileges = Pick<UserPrivileges, 'isPaidCustomer' | 'trialEndDate' | 'role'>;

const isAllowedToConsumePaidContent = (
    { isPaidCustomer, role, trialEndDate }: NeededPrivileges,
    isEmailVerified: boolean,
): boolean =>
    isEmailVerified &&
    (role === 'admin' || isPaidCustomer || (trialEndDate ? trialEndDate > Date.now() : false));

/**
 * Determines whether a user is considered an internal user based on their email address.
 *
 * An internal user is defined as one whose email address ends with the configured
 * {@link INTERNAL_EMAIL_SUFFIX}. If the provided email is `null`, `undefined`, or an
 * otherwise falsy value, this function returns `false`.
 *
 * @param email - The user's email address. May be a string, `null`, or `undefined`.
 * @returns `true` if the email is a non-empty string whose lowercase value ends with
 *          {@link INTERNAL_EMAIL_SUFFIX}; otherwise, `false`.
 */
const isInternalUser = (email: string | null | undefined): boolean =>
    !!email && email.toLowerCase().endsWith(INTERNAL_EMAIL_SUFFIX);

export { isAllowedToConsumePaidContent, isInternalUser };
